import axiosInstance from "../axiosInstance";
import ApiRequest from "../axiosInstance/request";
import { endpoints } from "../endpoints";

export const totalvideoListEditorDashboard = (data) => {
  const { pageParam, from, to } = data;
  return new Promise((resolve, reject) => {
    ApiRequest.get(
      `${
        endpoints.editorDashboard.videoList
      }?urgent_posting_request=yes&page=${pageParam} ${
        from && to ? `&from=${from}&to=${to}` : ""
      }`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const editorsubmissionsmutation = async (body) => {
  try {
    const res = await ApiRequest.post(
      endpoints.editorDashboard.editorSubmission,
      body
    );

    return res;
  } catch (error) {
    return error;
  }
};

export const searchDataCallEditor = (query, pageParam) => {
  // console.warn("🚀 ~ file: cms.api.js:24 ~ submissionsList ~ body:", query);
  return new Promise((resolve, reject) => {
    ApiRequest.post(
      `${endpoints.editorDashboard.videoList}?search=${query}&page=${pageParam}`
    )
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const editorDashboardpendingtitlingpageMutation = async (datas) => {
  function buildQueryString() {
    const queryParts = [];
    // console.warn("datas", datas);
    for (const key in datas) {
      // console.warn("key", key);
      if (
        key !== "null" &&
        datas.hasOwnProperty(key) &&
        datas[key] !== null &&
        datas[key] !== undefined &&
        datas[key] !== ""
      ) {
        const value = encodeURIComponent(datas[key]);
        queryParts.push(`${key}=${value}`);
      }
    }

    return queryParts.join("&");
  }

  try {
    // console.warn("call-----------------------------------------------------------------------------------------------");
    let queryString = buildQueryString();
    console.warn("queryString-------------", queryString);

    const res = await axiosInstance.get(
      `${endpoints.editorDashboard.videoList}?${queryString}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const editorDashboardPublishpageMutation = async (datas) => {
  function buildQueryString() {
    const queryParts = [];
    // console.warn("datas", datas);
    for (const key in datas) {
      // console.warn("key", key);
      if (
        key !== "null" &&
        datas.hasOwnProperty(key) &&
        datas[key] !== null &&
        datas[key] !== undefined &&
        datas[key] !== ""
      ) {
        const value = encodeURIComponent(datas[key]);
        queryParts.push(`${key}=${value}`);
      }
    }

    return queryParts.join("&");
  }

  try {
    // console.warn("call-----------------------------------------------------------------------------------------------");
    let queryString = buildQueryString();
    console.warn("queryString-------------", queryString);

    const res = await axiosInstance.get(
      `${endpoints.editorDashboard.videoList}?${queryString}`
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const editorProfileUpdateMutation = async (body) => {
  try {
    const res = await ApiRequest.post(
      endpoints.editorDashboard.updateUser,
      body
    );

    return res;
  } catch (error) {
    return error;
  }
};

export const editorDashboardVideoDetails = (data) => {
  const { pageParam, from, to } = data;
  return new Promise((resolve, reject) => {
    ApiRequest.get(`${endpoints.editorDashboard.videoDetails}/${data}`)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
